import { coreTools, filterNavLinksByFeatureFlags } from '#forgd/app/composables/nav'
import { ForgdToolsIcon } from '@forgd/ui-kit/icons'
import { hash } from 'ohash'

export function useInHouseToolsSearchGroup() {
  return {
    key: 'in-house-tools' as const,
    label: 'In-House Tools',
    commands: filterNavLinksByFeatureFlags(coreTools)
      .map(item => ({
        ...item,
        id: hash(item),
        icon: ForgdToolsIcon,
      })),
  }
}
